import { useState, useRef, useEffect } from "react";
import emailjs from '@emailjs/browser';

export default function Uwu() {
    const PUBLIC_KEY = 'u2WwY0y5ynMo4gwPU';
    const SERVICE_ID = 'service_tu4e3lc';
    const TEMPLATE_ID = 'template_o39nfhp';
    const noTexts = ["No 😒", "Are you sure? 🤨", "Really??? 😭", "Try again 😝", "Pick Yes 😈", "Wrong answer ❌", "Not this 🥸", "Other button ☝️"];
    const [yesSize, setYesSize] = useState(20);
    const [noChasedTimes, setNoChasedTimes] = useState(0);
    const [yesClicked, setYesClicked] = useState(false);
    const [giveUp, setGiveUp] = useState(false);
    const [transitioning, setTransitioning] = useState(false);
    const [visited, setVisited] = useState(false);
    const noBtnRef = useRef(null);

    useEffect(() => {
        document.title = 'for sleeping beauty <3';
        
        // TRIGGER VISIT
        if (!visited) {
            setVisited(true);
            sendEmail();
        }
    }, [visited]);

    const form = useRef();

    const sendEmail = (e) => {
        e?.preventDefault();

        emailjs
            .sendForm(SERVICE_ID, TEMPLATE_ID, form.current, {
                publicKey: PUBLIC_KEY
            })
            .catch(console.error);
    };

    const handleMouseMove = (e) => {
        const btn = noBtnRef.current;
        if (!btn) return;

        const rect = btn.getBoundingClientRect();
        const btnX = rect.left + rect.width / 2;
        const btnY = rect.top + rect.height / 2;

        const distance = Math.hypot(e.clientX - btnX, e.clientY - btnY);

        // If cursor gets close, move the "No" button away
        if (distance < 80) {
            let newX, newY;

            while (true) {
                newX = Math.random() * (window.innerWidth - rect.width);
                newY = Math.random() * (window.innerHeight - rect.height);

                if (distance < Math.hypot(newX - e.clientX, newY - e.clientY)) break;
            }

            if (!transitioning) {
                btn.style.position = "absolute";
                btn.style.left = `${newX}px`;
                btn.style.top = `${newY}px`;
                btn.innerText = noTexts[Math.floor(Math.random() * noTexts.length)];
                setYesSize((prev) => prev + 4);
                setNoChasedTimes((prev) => ++prev);
            }
            setTransitioning(true);
            btn.disabled = true;

            setGiveUp(noChasedTimes >= 100);
        } else {
            setTransitioning(false);
            btn.disabled = false;
        }
    };

    return (
    <div
        onMouseMove={handleMouseMove}
        style={{
        height: "100vh",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        fontFamily: "sans-serif",
        textAlign: "center",
        }}
    >
        <form ref={form} onSubmit={sendEmail}>
            <input type="hidden" name='subject' value='SHE VISITED!!!' />
            <input type="hidden" name='content' value={'SHE VISITED THE QUESTION!!! BE PREPARED! 👀'} />
        </form>

        {!giveUp ? (
            <>
                {!yesClicked ? (
                <>
                    <div class="progress fixed-top" role="progressbar" aria-label="Danger example" aria-valuenow={0} aria-valuemin="0" aria-valuemax="100">
                        <div id='progessBar' class="progress-bar progress-bar-striped progress-bar-animated bg-danger" style={{
                            width: noChasedTimes + '%'
                        }}></div>
                    </div>

                    <h1>May I be your boyfriend?</h1>
                    <h1>🥺</h1>
                    <h4>👉👈</h4>

                    <div style={{ marginTop: "30px" }}>
                        <button
                            onClick={() => setYesClicked(true)}
                            style={{
                            padding: "10px 20px",
                            fontSize: `${yesSize}px`,
                            backgroundColor: "white",
                            borderColor: "yellow",
                            borderRadius: "10px",
                            cursor: "pointer",
                            }}
                        >
                            Yes 💛
                        </button>

                        <button
                            ref={noBtnRef}
                            style={{
                            padding: "10px 20px",
                            fontSize: "20px",
                            backgroundColor: "white",
                            borderColor: "red",
                            borderRadius: "10px",
                            marginLeft: "40px",
                            cursor: "not-allowed",
                            transition: 'all 0.2s ease-out'
                            }}
                        >
                            No 👿
                        </button>
                    </div>
                </>
                ) : (
                <>
                    <h1>Yay!! I knew you'd say yes!</h1>
                    <h1>😎💖</h1>
                    <p class='fs-6 fw-light text-muted'>(i'm so happy 🥹)</p>
                    <form ref={form} onSubmit={sendEmail} class='mb-5'>
                        <input type="hidden" name='subject' value='SHE ANSWERED 🫣❤️' />
                        <input type="hidden" name='content' value={'SHE HAS ANSWERED YOUR QUESTION!!! HURRY UP AND TALK TO HER!!! TELL HER YOU LOVE HER!!! BTW, SHE CHASED THAT NO BUTTON ' + noChasedTimes + ' TIMES!'} />
                        <input type='submit' value='Click this to let me know ❤️' class='btn btn-warning btn-sm' data-bs-toggle='modal' data-bs-target='#thankYou' />
                    </form>

                    {
                        (noChasedTimes >= 1) ?
                        <p class='fw-light mt-5'>You chased that <span class='fw-bold badge bg-secondary'>No</span> <span class='fw-bold'>{noChasedTimes}</span> time{(noChasedTimes === 1) ? <></> : <>s</>}. 🙄</p>
                        :
                        <p class='fw-light mt-5'>You didn't hesitate at all. 🫣🥹</p>
                    }

                    {/* MODAL */}
                    <div class="modal fade" id="thankYou" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
                        <div class="modal-dialog modal-md modal-dialog-centered">
                            <div class="modal-content">
                            <div class="modal-header">
                                <h1 class="modal-title fs-5" id="staticBackdropLabel">SENT TO KEVII</h1>
                            </div>
                            <div class="modal-body">
                                THANK YOU FOR LETTING ME KNOW 🥹
                            </div>
                            <div class="modal-footer">
                                <button type="button" class="btn btn-outline-warning" data-bs-dismiss="modal">🥰</button>
                            </div>
                            </div>
                        </div>
                    </div>
                </>
                )}
            </>
        ) : (
            // GIVE UP =========================================================================
            <>
                <h1>Fine. I give up.</h1>
                <h1>😭</h1>

                <div style={{ marginTop: "30px" }}>
                    <form ref={form} onSubmit={sendEmail}>
                        <input type="hidden" name='subject' value='OH NO.' />
                        <input type="hidden" name='content' value={'BAD NEWS. SHE SAID SORRY 😭💔'} />
                        <input type='submit' value='Sorry 💔' data-bs-toggle='modal' data-bs-target='#sorry'
                            style={{
                            padding: "10px 20px",
                            fontSize: "20px",
                            backgroundColor: "white",
                            borderColor: "red",
                            borderRadius: "10px"
                            }}
                        />
                    </form>
                </div>

                {/* MODAL */}
                <div class="modal fade" id="sorry" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
                    <div class="modal-dialog modal-sm modal-dialog-centered">
                        <div class="modal-content bg-danger">
                            <div class="modal-body">
                                😭<br/>
                                <button type="button" class="btn btn-outline-warning mt-5" data-bs-dismiss="modal">😭</button>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        )}
    </div>
  );
}